// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"689da0a6","408":"ab69aebd","571":"e7586d51","618":"504947aa","973":"504947aa"}[chunkId] + ".chunk.css";
};